import React, { useState, useEffect, useRef } from 'react';
import {
  Button,
  Spinner,
  Row,
  Col,
  Card,
  CardBody,
  Input,
  FormGroup,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Label,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  ListGroup, ListGroupItem,
} from 'reactstrap';
import { CiEdit } from "react-icons/ci";

import { GiMusicalScore } from "react-icons/gi";
import { Plus, Music, Youtube, FileText, Eye } from 'react-feather';
import { getSongURL, signedURL, uploadResourse, addResource, addSong, songByTags, editSong } from '../../../../Api/lms/apiUtils'; 
import PreviewModal from './songpreview';
import { LuMic2 } from "react-icons/lu";
import { toast } from "react-toastify";
import Select, { MultiValue } from "react-select";
import { tagsMap } from './tags';
import classnames from 'classnames';

type UploadedFiles = {
  lyricsId?: any| null;
  annotationId?: any | null;
  songId1?: any | null;
  songId2?: any | null;
  demoTrackId1?: any| null;
  demoTrackId2?: any| null;
  karaokeId1?: any | null;
  karaokeId2?:any| null;
  backingTrackId1?: any| null;
  backingTrackId2?: any | null;
  songNotesId?: any | null;

};

interface Song {
  name: string;
  song_url:any;
karaoke_url:any;
karaokeFileUrl1: any;
karaokeFileUrl2: any;
annotationFileUrl: any;
lyricsFileUrl:any;
songFileUrl2:any;
songFileUrl1:any;
demo_track_url:any;
demoTrackFileUrl1: any;
demoTrackFileUrl2: any;
backing_track_url:any;
backingTrackFileUrl1: any;
backingTrackFileUrl2: any;
songNotesFileUrl: any;
  mainLink: string;
  song_id:any;
  tags:any
  karaokeLink: string;
  lyricsFile: File | null;
  annotationFile: File | null;
  kidFriendly: boolean;
  notation_link: string;
  mainSongFile1: File | null;
  songId1: any;
  mainSongFile2: File | null;
  demoTrackFile1: File | null;
  demoTrackFile2: File | null;
  song_name:any;
  karaokeFile1: File | null;
  karaokeFile2: File | null;
  backingTrackFile1: File | null;
  backingTrackFile2: File | null;
  songsNotesFile: File | null;
  demoTrackLink :any;
  backingTrackLink:any;
}


interface TagOption {
  value: number;
  label: string;
}

function SongsList() {
  const [songs, setSongs] = useState<Song[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [searchQuery, setSearchQuery] = useState<string>('');
  const [page, setPage] = useState<number>(1);
  const [hasMore, setHasMore] = useState<boolean>(true);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isPreviewOpen, setIsPreviewOpen] = useState(false);
  const [previewUrl, setPreviewUrl] = useState<string | null>(null);
  const [isSaving, setIsSaving] = useState<boolean>(false);
  const [addSongTags, setAddSongTags] = useState<any[]>([]);
  const [searchTags, setSearchTags] = useState<any[]>([]);
  const [activeTab, setActiveTab] = useState<string>('1');
  const[songActive, setSongActive] = useState<any>('1');
  const lastSongRef = useRef<HTMLDivElement | null>(null);
  const { tagsList, isLoading: tagsLoading } = tagsMap()
  const [songModalOpen, setModalSongOpen] = useState(false);
  const [editingSong, setEditingSong] = useState<Song | null>(null);
const [isEditModalOpen, setIsEditModalOpen] = useState(false);
const [songToEdit, setSongToEdit] = useState<Song | null>(null);
const [selectedEditTags, setSelectedEditTags] = useState<any[]>([]); // Use string[] instead of number[]

const [selectedSong, setSelectedSong] = useState(null); 
  const tagOptions = tagsList.map((tag) => ({ value: tag.id, label: tag.name }));

  useEffect(() => {
    if (songToEdit) {
      console.log("Song to Edit:", songToEdit);
    }
  }, [songToEdit]);

  const toggleSongModal = () => {

    setModalSongOpen(!songModalOpen);
  }
  const handleViewSongDetails = (song : any) => {
    setSelectedSong(song);  // Set the selected song when the button is clicked
    toggleSongModal();          // Open the modal
  };


  const openEditModal = (song: Song) => {
    setIsEditModalOpen(true);
    const validTags = Array.isArray(song.tags)
      ? song.tags.filter((tag: any) => tag !== null )
      : [];
  
    // Map valid tags to match the `tagOptions` structure
    const initialTags = validTags.map((tag: any) => {
      const matchingTag = tagOptions.find((option) => option.label === tag);
      return matchingTag ? matchingTag : { label: tag, value: tag }; // Fallback to using the tag as both label and value
    });
  
    setSelectedEditTags(initialTags); // Update the selected tags state
    setSongToEdit({ ...song }); // Set the song being edited
 // Open the modal
  };
  
  
  const songDetails: { key: keyof Song; label: any; newTab?: boolean }[] = [
    { key: "song_url", label: "Origin Song Link", newTab: true }, // open in new tab
    { key: "songFileUrl1", label: "Song File 1" },
    { key: "songFileUrl2", label: "Song File 2" },
    { key: "karaokeFileUrl1", label: "Karaoke 1" },
    { key: "karaokeFileUrl2", label: "Karaoke 2" },
    { key: "karaoke_url", label: "Karaoke Link", newTab: true }, // open in new tab
    { key: "annotationFileUrl", label: "Notation File", },
    { key: "notation_link", label: "Notation Link", newTab: true }, // open in new tab
    { key: "demo_track_url", label: "Demo Track", newTab: true }, // open in new tab
    { key: "demoTrackFileUrl1", label: "Demo Track 1" },
    { key: "demoTrackFileUrl2", label: "Demo Track 2" },
    { key: "backing_track_url", label: "Backing Track" , newTab: true},
    { key: "backingTrackFileUrl1", label: "Backing Track 1" },
    { key: "backingTrackFileUrl2", label: "Backing Track 2" },
    { key: "songNotesFileUrl", label: "Song Notes"},
    { key: "lyricsFileUrl", label: "Lyrics File" },
  ];

  const [song, setSong] = useState({
    name: '',
    mainLink: '',
    karaokeLink: '',
    demoTrackLink:'',
    backingTrackLink: '',
    lyricsFile: null as File | null,
    annotationFile: null as File | null,
    kidFriendly: false,
    notation_link: '',
    mainSongFile1: null as File | null,
    mainSongFile2: null as File | null,
    demoTrackFile1: null as File | null,
    demoTrackFile2: null as File | null,
    karaokeFile1: null as File | null,
    karaokeFile2: null as File | null,
    backingTrackFile1: null as File | null,
    backingTrackFile2: null as File | null,
    songsNotesFile: null as File | null,
    demoTrackFile: null as File | null,
    karaokeAudioFile: null as File | null,
    karaokeVideoFile: null as File | null,
    backingTrackFile: null as File | null,
    backingTrackOneFile: null as File | null,
    backingTrackTwoFile: null as File | null,

  });

  const toggleSongTab = (tab: string) => {
    setSongActive(tab);
  };

  const toggleTab = (tab: string) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
      setSongs([]);
      setPage(1);
      setHasMore(true);
      fetchSongs(1);  // Fetch all songs
    }
  };

  const toggleSTab = (tab: string) => {
    if (activeTab !== tab) {
     // Fetch all songs
    }
  };

  const fetchSongs = async (pageNumber: number) => {
    setIsLoading(true);
    try {
      const response = await getSongURL(searchQuery, pageNumber, 20);
      console.log("Fetched Songs Response:", response);
  
      const newSongs = response?.results || [];
      console.log("Newly Fetched Songs:", newSongs);
  
      if (pageNumber === 1) {
        setSongs(newSongs); // Replace entire list for first page
      } else {
        setSongs((prevSongs) => [...prevSongs, ...newSongs]); // Append for pagination
      }
  
      setHasMore(newSongs.length > 0);
    } catch (error) {
      console.error("Error fetching songs:", error);
    } finally {
      setIsLoading(false);
    }
  };
  
 const uploadAndStoreFile = async (file: File | null, key: string, uploadFile: (file: File) => Promise<any>) => {
    if (file) {
      const response = await uploadFile(file);
      return response?.status === 200 ? response.data?.resource?.[0]?.resource_id || null : null;
    }
    return null;
  };
  
 const updateSong = async (
    songToEdit: any,
    addSongTags: any[],
    editSong: (songId: string, body: any) => Promise<any>,
    uploadFile: (file: File) => Promise<any>,
    fetchSongs: () => void,
    toast: any,
    closeEditModal?: () => void
  ) => {
    if (!songToEdit) return;
  
    try {
      console.log("Editing song with ID:", songToEdit.song_id); 
      let uploadedFiles: Record<string, string | null> = {
        lyricsId: songToEdit.lyrics_id || null,
        annotationId: songToEdit.annotation_id || null,
        songId1: songToEdit.song_id_1 || null,
        songId2: songToEdit.song_id_2 || null,
        demoTrackId1: songToEdit.demo_track_id_1 || null,
        demoTrackId2: songToEdit.demo_track_id_2 || null,
        karaokeId1: songToEdit.karaoke_id_1 || null,
        karaokeId2: songToEdit.karaoke_id_2 || null,
        backingTrackId1: songToEdit.backing_track_id_1 || null,
        backingTrackId2: songToEdit.backing_track_id_2 || null,
        songNotesId: songToEdit.song_notes_id || null,
      };
  
      // Upload all necessary files
      const fileKeys = [
        { key: "lyricsFile", idKey: "lyricsId" },
        { key: "annotationFile", idKey: "annotationId" },
        { key: "mainSongFile1", idKey: "songId1" },
        { key: "mainSongFile2", idKey: "songId2" },
        { key: "demoTrackFile1", idKey: "demoTrackId1" },
        { key: "demoTrackFile2", idKey: "demoTrackId2" },
        { key: "karaokeFile1", idKey: "karaokeId1" },
        { key: "karaokeFile2", idKey: "karaokeId2" },
        { key: "backingTrackFile1", idKey: "backingTrackId1" },
        { key: "backingTrackFile2", idKey: "backingTrackId2" },
        { key: "songsNotesFile", idKey: "songNotesId" },
      ];
  
      await Promise.all(
        fileKeys.map(async ({ key, idKey }) => {
          uploadedFiles[idKey] = await uploadAndStoreFile(songToEdit[key], idKey, uploadFile);
        })
      );
  
      // Construct updated song object
      const updatedSong = {
        songName: songToEdit.song_name || songToEdit.name,
        songUrl: songToEdit.song_url || songToEdit.mainLink,
        karaokeUrl: songToEdit.karaoke_url || songToEdit.karaokeLink,
        demoTrackUrl: songToEdit.demo_track_url || songToEdit.demoTrackLink,
        backingTrackUrl: songToEdit.backing_track_url || songToEdit.backingTrackLink,
        notation_link: songToEdit.notation_link,
        kidsFriendly: songToEdit.kids_friendly || songToEdit.kidFriendly,
        tags: selectedEditTags.map((tag) => tag.value),
        ...uploadedFiles, // Merging uploaded file IDs into the object
      };
  
      // Update song in the database
      const response = await editSong(songToEdit.song_id, updatedSong);
      
      if (response.status === 200) {
        fetchSongs();
        toast.success("Song updated successfully");
        if (closeEditModal) closeEditModal();
      } else {
        toast.error("Failed to update song");
      }
    } catch (error) {
      console.error("Error updating song:", error);
      toast.error("Error updating song");
    }
  };
  

  const handleEditSong = async (editedSong: Song, addSongTags: any[] = []) => {
    setIsLoading(true);
    setIsSaving(true);
    
    await updateSong(
      editedSong,
      addSongTags ?? [],  // <-- Ensure it never becomes undefined
      editSong,
      uploadFile,
      () => fetchSongs(1),
      toast,
      () => {
        setEditingSong(null);
        setIsEditModalOpen(false);
        setPage(1);
      }
    );
  
    setIsLoading(false);
    setIsSaving(false);
  };
  
  const fetchSongsByTags = async (tags: MultiValue<TagOption>) => {
    // Ensure we have a valid tag list
    if (tags.length === 0) {
      setSongs([]);  // Clear songs if no tags are selected
      setHasMore(false);
      return;
    }
  
    setIsLoading(true);
    try {
      const response = await songByTags({
        tagIds: tags.map(tag => tag.value),
        limit: 20,
        offset: (page - 1) * 20,
      });
      const newSongs = response.data.songs || [];
      setSongs((prevSongs) => [...prevSongs, ...newSongs]);
      if (newSongs.length === 0) {
        setHasMore(false);
      }
    } catch (error) {
      console.error('Error fetching songs by tags:', error);
    } finally {
      setIsLoading(false);
    }
  };
  
  const closeEditModal = () => {
    setIsEditModalOpen(false);
    setSongToEdit(null);
  };


  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchQuery(e.target.value);
    setPage(1);
    setHasMore(true);
    setSongs([]);
    fetchSongs(1);
  };
  

  const handleAddSongTagChange = (selectedOptions: MultiValue<TagOption>) => {
    setAddSongTags([...selectedOptions]);
  };
  const handleSearchTagChange = (selectedOptions: MultiValue<TagOption>) => {
    const updatedTags = Array.from(selectedOptions || []);
    setSearchTags(updatedTags); 
  
    // Clear current songs and reset pagination
    setPage(1);
    setHasMore(true);
    setSongs([]);
  
    // Trigger fetch after state update
    fetchSongsByTags(updatedTags);
  };
  
  const handleScroll = () => {
    if (
      lastSongRef.current &&
      lastSongRef.current.getBoundingClientRect().bottom <= window.innerHeight + 100 &&
      hasMore &&
      !isLoading
    ) {
      setPage((prevPage) => prevPage + 1);
    }
  };

  useEffect(() => {
    if (activeTab === '1') {

      fetchSongs(page);
      setHasMore(true);
    }
  }, [page, activeTab]); 
  

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [hasMore, isLoading]);

  const handleAddSong = async (song: any, addSongTags: any) => {
    let uploadedFiles: UploadedFiles = {};
    setIsLoading(true);
    setIsSaving(true);
  
    try {
      // Helper function to upload files correctly
      const uploadAndStoreFile = async (file: File | null | undefined, key: keyof UploadedFiles) => {
        if (file) {
          const response = await uploadFile(file);
          console.log(`File upload response for ${key}:`, response); 
          if (response?.status === 200) {
            uploadedFiles[key] = response.data?.resource?.[0]?.resource_id || null; 
            console.log(`Stored in uploadedFiles[${key}]:`, uploadedFiles[key]); 
          }
        }
      };
  
      // Upload all files and ensure they finish before using uploadedFiles
      await Promise.all([
        uploadAndStoreFile(song.lyricsFile ?? null, "lyricsId"),
        uploadAndStoreFile(song.annotationFile ?? null, "annotationId"),
        uploadAndStoreFile(song.mainSongFile1 ?? null, "songId1"),
        uploadAndStoreFile(song.mainSongFile2 ?? null, "songId2"),
        uploadAndStoreFile(song.demoTrackFile1 ?? null, "demoTrackId1"),
        uploadAndStoreFile(song.demoTrackFile2 ?? null, "demoTrackId2"),
        uploadAndStoreFile(song.karaokeFile1 ?? null, "karaokeId1"),
        uploadAndStoreFile(song.karaokeFile2 ?? null, "karaokeId2"),
        uploadAndStoreFile(song.backingTrackFile1 ?? null, "backingTrackId1"),
        uploadAndStoreFile(song.backingTrackFile2 ?? null, "backingTrackId2"),
        uploadAndStoreFile(song.songsNotesFile ?? null, "songNotesId"),
      ]);
  
      console.log("Final uploadedFiles object before constructing payload:", uploadedFiles);
  
      // Construct the song object with uploaded file IDs
      const newSong = {
        songName: song.name,
        songUrl: song.mainLink,
        karaokeUrl: song.karaokeLink,
        lyricsId: uploadedFiles.lyricsId || null,
        annotationId: uploadedFiles.annotationId || null,
        kidsFriendly: song.kidFriendly,
        notation_link: song.notation_link,
        tags: addSongTags.map((tag:any) => tag.value),
        songId1: uploadedFiles.songId1 || null,
        songId2: uploadedFiles.songId2 || null,
        karaokeId1: uploadedFiles.karaokeId1 || null,
        karaokeId2: uploadedFiles.karaokeId2 || null,
        demoTrackUrl: song.demoTrackLink ?? "",
        demoTrackId1: uploadedFiles.demoTrackId1 || null,
        demoTrackId2: uploadedFiles.demoTrackId2 || null,
        backingTrackUrl: song.backingTrackLink ?? "",
        backingTrackId1: uploadedFiles.backingTrackId1 || null,
        backingTrackId2: uploadedFiles.backingTrackId2 || null,
        songNotesId: uploadedFiles.songNotesId || null,
      };
  
      console.log("New Song Payload:", newSong);
  
      // Add the new song to the database
      await addSong(newSong);
   
      console.log("Song successfully added!");
    
      toast.success("Song added successfully!");
  
      // Reset song state after successful addition
      setSong({
        name: '',
        mainLink: '',
        backingTrackLink: '',
        karaokeLink: '',
        demoTrackLink: '',
        lyricsFile: null,
        annotationFile: null,
        kidFriendly: false,
        notation_link: '',
        mainSongFile1: null,
        mainSongFile2: null,
        demoTrackFile1: null,
        demoTrackFile2: null,
        karaokeFile1: null,
        karaokeFile2: null,
        backingTrackFile1: null,
        backingTrackFile2: null,
        songsNotesFile: null,
        demoTrackFile: null,
        karaokeAudioFile: null,
        karaokeVideoFile: null,
        backingTrackFile: null,
        backingTrackOneFile: null,
        backingTrackTwoFile: null,
      });
      
      // Optionally close the modal or update UI
      toggleModal();
      setPage(1);
      fetchSongs(page);
    } catch (error) {
      console.error("Error adding song:", error);
      toast.error("Error adding song");
    } finally {
      setIsLoading(false);
      setIsSaving(false);
    }
  };
  
  
    
  
  

  const handlePreview = (fileUrl: any) => {
    setPreviewUrl(fileUrl);
    setIsPreviewOpen(true);
  };

  const handleFileChange = (file: File | null, key: string) => {
    if (songToEdit) {
      setSongToEdit({ ...songToEdit, [key]: file });
    }
  };
  
  const handleInputChange = (field: keyof Song, value: any) => {
    if (songToEdit) {
      setSongToEdit({ ...songToEdit, [field]: value });
    }
  };

  const closePreview = () => {
    setIsPreviewOpen(false);
    setPreviewUrl(null);
  };

  const uploadFile = async (file: File) => {
    try {
      const fileExtension = file.name.split('.').pop();
      let fName = file.name.split(' ').join('_');
      const response = await signedURL({ fileName: fName, fileType: fileExtension });
      if (response.status === 200) {
        let resourseName = response.data.fileName;
        const { signedUrl } = response.data;
        const uploadResponse = await uploadResourse(signedUrl, file);
        if (uploadResponse.status === 200) {
          const resourceResponse = await addResource({
            resourceName: resourseName,
            displayName: file.name,
            type: fileExtension,
            description: "",
            url: "",
          });
          if (resourceResponse.status === 200) {
            return resourceResponse;
          }
        }
      }
    } catch (error) {
      console.error('Error during file upload process', error);
    }
    return null;
  };

  const toggleModal = () => setIsModalOpen(!isModalOpen);

  return (
    <div>
      <Nav tabs>
        <NavItem>
          <NavLink
            className={classnames({ active: activeTab === '1' })}
            onClick={() => toggleTab('1')}
          >
            Search by Songs
          </NavLink>
        </NavItem>
        <NavItem>
          <NavLink
            className={classnames({ active: activeTab === '2' })}
            onClick={() => toggleTab('2')}
          >
            Search by Tag
          </NavLink>
        </NavItem>
      </Nav>
      <div style={{ marginTop: '10px', textAlign: 'left' }}>
  <Button color="primary" onClick={toggleModal}>
    Add Song
  </Button>
</div>

      <TabContent activeTab={activeTab}>
        <TabPane tabId="1">
          <FormGroup style={{ marginTop: '10px' }}>
            <Input
              type="text"
              placeholder="Search By Song Name..."
              value={searchQuery}
              onChange={handleSearchChange}
            />
          </FormGroup>
        </TabPane>
        <TabPane tabId="2">
          <FormGroup style={{ marginTop: '10px' }}>
            <Select
              isMulti
              options={tagOptions}
              onChange={handleSearchTagChange}
              placeholder="Search by tags..."
            />
          </FormGroup>
        </TabPane>
      </TabContent>

      {/* <Button color="primary" onClick={toggleModal} style={{ marginBottom: '10px' }}>
        <Plus size={18} /> Add Song
      </Button> */}

      {isLoading && songs.length === 0 ? (
        <Row className="user-cards-items user-card-wrapper" style={{ marginTop: '15px' }}>
          <Col xs="12" className="text-center">
            <Spinner color="primary" />
            <p>Loading songs...</p>
          </Col>
        </Row>
      ) : (
        <Row className="user-cards-items user-card-wrapper">
          {songs.length > 0 ? (
            songs.map((song, index) => (
              <Col
                key={song.song_id}
                xl="4"
                sm="6"
                xxl="3"
                className="col-ed-4 box-col-4"
              >
              <div ref={index === songs.length - 1 ? lastSongRef : null}>
  <Card style={{ maxHeight: '80vh', height: '200px', overflowY: 'hidden', marginTop: '20px', position: 'relative' }}>
    <CardBody>


      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        {/* Song Name */}
        <div style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}>
          <h6 style={{ marginLeft: '10px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
            {song.song_name}
          </h6>
        </div>

        <Button color="secondary" onClick={() => handleViewSongDetails(song)}>
          <Eye size={18} />
               </Button>
               <Button color="link" onClick={() => openEditModal(song)}>
  <CiEdit size={18} />
</Button>
      </div>

   
    
      <div style={{ marginTop: '10px' }}>
        {Array.isArray(song.tags) && song.tags.filter((tag) => tag).length > 0 ? (
          <div>
            <strong>Tags:</strong>
            <div style={{ marginLeft: '5px', display: 'flex', flexWrap: 'wrap', gap: '5px', maxHeight: '80px', overflowY: 'auto' }}>

              {song.tags.filter((tag) => tag).map((tag, index) => (
                <span key={index} style={{ backgroundColor: '#f1f1f1', borderRadius: '12px', padding: '4px 10px', fontSize: '12px', color: '#333' }}>
                {tag}
              </span>
              ))}
            </div>
          </div>
        ) : (
          <div style={{ fontStyle: 'italic', color: '#888' }}>No tags available</div>
        )}
      </div>
    </CardBody>
  </Card>
</div>

              </Col>
            ))
          ) : (
            <p>No songs available.</p>
          )}
        </Row>
      )}
<Modal isOpen={songModalOpen} toggle={toggleSongModal} className="custom-modal">
  <ModalHeader toggle={toggleSongModal}>Song details</ModalHeader>
  <ModalBody>
    {selectedSong && (
      <ListGroup>
        {songDetails.map(({ key, label, newTab }) =>
          selectedSong[key] ? (
            <ListGroupItem tag="div" action key={key}>
              {newTab ? (
                <a href={selectedSong[key]} target="_blank" rel="noopener noreferrer">
                  {label}
                </a>
              ) : (
                <span
                  onClick={(e) => {
                    e.stopPropagation();
                    handlePreview(selectedSong[key]);
                  }}
                  style={{ cursor: 'pointer' }}
                >
                  {label}
                </span>
              )}
            </ListGroupItem>
          ) : null
        )}
      </ListGroup>
    )}
  </ModalBody>
  <ModalFooter>
    <Button color="secondary" onClick={toggleSongModal}>
      Close
    </Button>
  </ModalFooter>
</Modal>
<Modal isOpen={isModalOpen} toggle={toggleModal}>
  <ModalHeader toggle={toggleModal}>Add Song</ModalHeader>

  <ModalBody style={{ maxHeight: '70vh', overflowY: 'auto' }}>
   
 
        {/* Add Link Section */}
        <FormGroup>
          <Label><b>Enter Song Name</b></Label>
          <Input
            type="text"
            value={song.name}
            onChange={(e) => setSong({ ...song, name: e.target.value })}
          />
        </FormGroup>
        <FormGroup>
          <Label><b>Original Song Link</b></Label>
          <Input
            type="url"
            value={song.mainLink}
            onChange={(e) => setSong({ ...song, mainLink: e.target.value })}
          />
        </FormGroup>
        <FormGroup>
          <Label><b>Original Song File 1</b></Label>
          <Input
            type="file"
            accept=".mp3,.wav,.m4a,.mp4,.mov,.avi,.mkv"
    
            onChange={(e) => setSong({ ...song, mainSongFile1: e.target.files ? e.target.files[0] : null })}
          
          />
        </FormGroup>

        <FormGroup>
          <Label><b>Original Song File 2</b></Label>
          <Input
            type="file"
            accept=".mp3,.wav,.m4a,.mp4,.mov,.avi,.mkv"
    
              onChange={(e) => setSong({ ...song, mainSongFile2: e.target.files ? e.target.files[0] : null })}
          
          />
        </FormGroup>
      
    
        <FormGroup>
          <Label><b>Karaoke Song Link</b></Label>
          <Input
            type="url"
            value={song.karaokeLink}
            onChange={(e) => setSong({ ...song, karaokeLink: e.target.value })}
          />
        </FormGroup>
        <FormGroup >
          <Label><b>Karaoke 1</b></Label>
          <Input
            type="file"
            accept=".mp3,.wav,.m4a,.mp4,.mov,.avi,.mkv"
            onChange={(e) =>
              setSong({ ...song, karaokeFile1: e.target.files ? e.target.files[0] : null })
            }
          />
        </FormGroup>
        <FormGroup >
          <Label><b>Karaoke 2</b></Label>
          <Input
            type="file"
            accept=".mp3,.wav,.m4a,.mp4,.mov,.avi,.mkv"
            onChange={(e) =>
              setSong({ ...song, karaokeFile2: e.target.files ? e.target.files[0] : null })
            }
          />
        </FormGroup>
        <FormGroup>
          <Label><b>Notation Link</b></Label>
          <Input
            type="url"
            value={song.notation_link}
            onChange={(e) => setSong({ ...song, notation_link: e.target.value })}
          />
        </FormGroup>

        <FormGroup>
          <Label><b>Notation File</b></Label>
          <Input
            type="file"
            accept=".pdf"
            onChange={(e) =>
              setSong({ ...song, annotationFile: e.target.files ? e.target.files[0] : null })
            }
          />
        </FormGroup>
       
        
        <FormGroup >
          <Label><b>Demo Track</b></Label>
          <Input
            type="url"
            value={song.demoTrackLink}
            onChange={(e) => setSong({ ...song, demoTrackLink: e.target.value })}
          />
        </FormGroup>

        <FormGroup >
          <Label><b>Demo Track 1 </b></Label>
          <Input
              type="file"
              accept=".mp3,.wav,.m4a,.mp4,.mov,.avi,.mkv"       
              onChange={(e) => setSong({ ...song, demoTrackFile1: e.target.files ? e.target.files[0] : null })}
       
          />
        </FormGroup>
        <FormGroup >
          <Label><b>Demo Track 2 </b></Label>
          <Input
            type="file"
            accept=".mp3,.wav,.m4a,.mp4,.mov,.avi,.mkv"       
              onChange={(e) => setSong({ ...song, demoTrackFile2: e.target.files ? e.target.files[0] : null })}
       
          />
        </FormGroup>
      <FormGroup >
          <Label><b>Backing Track Original Tempo</b></Label>
          <Input
            type="url"
            accept=".mp3,.wav,.m4a,.mp4,.mov,.avi,.mkv"          // onChange={(e) =>
              onChange={(e) => setSong({ ...song, backingTrackLink: e.target.value })}
            // }
          />
        </FormGroup>

        <FormGroup >
          <Label><b>Backing Track Original Tempo 1</b></Label>
          <Input
            type="file"
            accept=".mp3,.wav,.m4a,.mp4,.mov,.avi,.mkv"          // onChange={(e) =>
              onChange={(e) => setSong({ ...song, backingTrackFile1: e.target.files ? e.target.files[0] : null })}
            // }
          />
        </FormGroup>
        <FormGroup >
          <Label><b>Backing Track Original Tempo 2</b></Label>
          <Input
            type="file"
            accept=".mp3,.wav,.m4a,.mp4,.mov,.avi,.mkv"          // onChange={(e) =>
              onChange={(e) => setSong({ ...song, backingTrackFile2: e.target.files ? e.target.files[0] : null })}
            // }
          />
        </FormGroup>
        <FormGroup>
          <Label><b>Lyrics</b></Label>
          <Input
            type="file"
            accept=".pdf"
            onChange={(e) =>
              setSong({ ...song, lyricsFile: e.target.files ? e.target.files[0] : null })
            }
          />
        </FormGroup>

        <FormGroup>
          <Label><b>Song Notes</b></Label>
          <Input
            type="file"
            accept=".pdf"
            // onChange={(e) =>
              onChange={(e) => setSong({ ...song, songsNotesFile: e.target.files ? e.target.files[0] : null })}
            // }
          />
        </FormGroup>
    <FormGroup>
      <Label><b>Select Tags</b></Label>
      <Select
        isMulti
        options={tagOptions}
        onChange={handleAddSongTagChange}
        placeholder="Select tags"
      />
    </FormGroup>
  </ModalBody>

  <ModalFooter>
    <Button
      color="primary"
      onClick={() => handleAddSong(song, addSongTags)}
      disabled={isSaving}
    >
      {isSaving ? <Spinner size="sm" /> : 'Save'}
    </Button>
  </ModalFooter>
</Modal>

<Modal isOpen={isEditModalOpen} toggle={closeEditModal}>
  <ModalHeader toggle={closeEditModal}>Edit Song</ModalHeader>
  <ModalBody style={{ maxHeight: '70vh', overflowY: 'auto' }}>
    {/* Shared Fields */}
    <FormGroup>
      <Label for="songName"><b>Song Name</b></Label>
      <Input
        type="text"
        id="songName"
        value={songToEdit?.song_name || ''}
        onChange={(e) => handleInputChange('song_name', e.target.value)}
      />
    </FormGroup>

    {/* Song URL */}
    <FormGroup>
      <Label for="songUrl"><b>Original Song Link</b></Label>
      <Input
        type="url"
        id="songUrl"
        value={songToEdit?.song_url || ''}
        onChange={(e) => handleInputChange('song_url', e.target.value)}
      />
    </FormGroup>
    <FormGroup>
      <Label><b>Original Song File 1</b></Label>
      <Input
        type="file"
        accept=".mp3,.wav,.m4a,.mp4"
        // value={songToEdit?.mainSongFile || ''}
        onChange={(e) =>
          handleFileChange(e.target.files ? e.target.files[0] : null, 'mainSongFile1')
        }
      />
    </FormGroup>
    <FormGroup>
      <Label><b>Original Song File 2</b></Label>
      <Input
        type="file"
        accept=".mp3,.wav,.m4a,.mp4"
        // value={songToEdit?.mainSongFile || ''}
        onChange={(e) =>
          handleFileChange(e.target.files ? e.target.files[0] : null, 'mainSongFile2')
        }
      />
    </FormGroup>
    <FormGroup>
      <Label for="karaokeUrl"><b>Karaoke URL</b></Label>
      <Input
        type="url"
        id="karaokeUrl"
        value={songToEdit?.karaoke_url || ''}
        onChange={(e) => handleInputChange('karaoke_url', e.target.value)}
      />
    </FormGroup>

    <FormGroup >
          <Label><b>Karaoke 1</b></Label>
          <Input
            type="file"
            accept=".mp3,.wav,.m4a,.mp4"
            // value={songToEdit?.karaokeAudioFile || ''}
            onChange={(e) =>
              handleFileChange(e.target.files ? e.target.files[0] : null, 'karaokeFile1')
            }        
          />
        </FormGroup>
        <FormGroup>
          <Label><b>Karaoke 2</b></Label>
          <Input
            type="file"
            accept=".mp3,.wav,.m4a,.mp4"
            // value={songToEdit?.karaokeVideoFile || ''}
            onChange={(e) =>
              handleFileChange(e.target.files ? e.target.files[0] : null, 'karaokeFile1')
            }
          
          />
        </FormGroup>
        <FormGroup className="mb-3">
      <Label><b>Demo Track</b></Label>
      <Input
        type="url"
        accept=".mp3,.wav,.m4a,.mp4"
        // value={songToEdit?.demoTrackFile|| ''}
        onChange={(e) => handleInputChange('demo_track_url', e.target.value)}
      />
    </FormGroup>

        <FormGroup className="mb-3">
      <Label><b>Demo Track 1</b></Label>
      <Input
        type="file"
        accept=".mp3,.wav,.m4a,.mp4"
        // value={songToEdit?.demoTrackFile|| ''}
        onChange={(e) =>
          handleFileChange(e.target.files ? e.target.files[0] : null, 'demoTrackFile1')
        }
      />
    </FormGroup>

        <FormGroup className="mb-3">
      <Label><b>Demo Track 2</b></Label>
      <Input
        type="file"
        accept=".mp3,.wav,.m4a,.mp4"
        // value={songToEdit?.demoTrackFile|| ''}
        onChange={(e) =>
          handleFileChange(e.target.files ? e.target.files[0] : null, 'demoTrackFile2')
        }
      />
    </FormGroup>

    {/* Backing Track Original Tempo */}
    <FormGroup className="mb-3">
      <Label><b>Backing Track Original Tempo</b></Label>
      <Input
        type="url"
        accept=".mp3,.wav,.m4a,.mp4"
        // value={songToEdit?.backingTrackFile|| ''}
        onChange={(e) => handleInputChange('backing_track_url', e.target.value)}

      />
    </FormGroup>
    <FormGroup className="mb-3">
  <Label><b>Backing Track Original Tempo 1</b></Label>
  <input
         className="form-control"
        //  ref={fileInputRef}
    type="file"
    accept=".mp3,.wav,.m4a,.mp4"
    onChange={(e) =>
      handleFileChange(e.target.files ? e.target.files[0] : null, 'backingTrackFile1')
    }  />
</FormGroup>
<FormGroup className="mb-3">
  <Label><b>Backing Track Original Tempo 2</b></Label>
  <input
         className="form-control"
        //  ref={fileInputRef}
    type="file"
    accept=".mp3,.wav,.m4a,.mp4"
    onChange={(e) =>
      handleFileChange(e.target.files ? e.target.files[0] : null, 'backingTrackFile2')
    }  />
</FormGroup>


    <FormGroup>
      <Label><b>Lyrics</b></Label>
      <Input
        type="file"
        accept=".pdf"
        // value={songToEdit?.lyricsFile|| ''}
        onChange={(e) =>
          handleFileChange(e.target.files ? e.target.files[0] : null, 'lyricsFile')
        }
      />
    </FormGroup>
    <FormGroup>
      <Label for="notationLink"><b>Notation Link</b></Label>
      <Input
        type="url"
        id="notationLink"
        value={songToEdit?.notation_link || ''}
        onChange={(e) => handleInputChange('notation_link', e.target.value)}
      />
    </FormGroup>
    <FormGroup>
      <Label><b>Notation File</b></Label>
      <Input
        type="file"
        accept=".pdf"
        // value={songToEdit?.annotationFile|| ''}
        onChange={(e) =>
          handleFileChange(e.target.files ? e.target.files[0] : null, 'annotationFile')
        }
      />
    </FormGroup>
 
    <FormGroup className="mb-3">
      <Label><b>Song Notes</b></Label>
      <Input
        type="file"
        accept=".mp3,.wav,.m4a,.mp4"
        // value={songToEdit?.demoTrackFile|| ''}
        onChange={(e) =>
          handleFileChange(e.target.files ? e.target.files[0] : null, 'songsNotesFile')
        }
      />
    </FormGroup>



    <FormGroup>
  <Label><b>Select Tags</b></Label>
  <Select
    isMulti
    value={selectedEditTags}
    options={tagOptions}
    onChange={(selectedOptions) => setSelectedEditTags(Array.from(selectedOptions || []))}
    placeholder="Select tags" // Optional: Add a placeholder
  />
</FormGroup>



  </ModalBody>
  <ModalFooter>
  <Button
  color="primary"
  onClick={() => songToEdit && handleEditSong(songToEdit)}
  disabled={!songToEdit} // Disable button if `songToEdit` is null
>
  Save Changes
</Button>
    <Button color="secondary" onClick={closeEditModal}>
      Cancel
    </Button>
  </ModalFooter>
</Modal>
      {previewUrl && (
        <PreviewModal
          isOpen={isPreviewOpen}
          toggle={closePreview}
          fileUrl={previewUrl}
          title="Lyrics Preview"
        />
      )}
    </div>
  );
}

export default SongsList;
